import moment from 'moment';
import * as yup from 'yup';
const { yupResolver } = require('@hookform/resolvers/yup');

export const missionRewardBannerFormDefaultValues = {
  id: '',
  formType: 'create',
  image: '',
  title: '',
  description: '',
  url: '',
  startDate: moment(new Date()),
  endDate: moment(new Date()).add(7, 'days'),
  display: true,
};

export const missionRewardBannerFormSchema = () => {
  return yupResolver(
    yup.object().shape({
      title: yup.string().required('กรุณาใส่หัวข้อ'),
      startDate: yup.string().required('กรุณาเลือกวันที่เริ่มต้น'),
      endDate: yup.string().required('กรุณาเลือกวันที่สิ้นสุด'),
    })
  );
};
